export default __webpack_public_path__ + "static/media/homeBG.052f14b2.jpg";